import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Col, Row } from "common/components";
import { Alert } from "components/bootstrap";
import { MarkdownPreview } from "components/common/MarkdownEditor";
import AssociatedEventDefs from "./AssociatedEventDefs";
import StepListView from "./StepListView";
const SectionHeaderRow = styled(Row)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.input.border};
  padding-bottom: ${({ theme }) => theme.spacings.sm};
`;
function EventProcedureDetailsView({
  eventProcedure,
  descriptionMaxHeight = 250,
  row = false,
  withAssocEntities = false,
  eventId = void 0
}) {
  var _a, _b, _c;
  const { t } = useTranslation("enterprise_security_events");
  const Container = row ? Row : Col;
  return /* @__PURE__ */ React.createElement(Container, { $align: "stretch" }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(SectionHeaderRow, null, /* @__PURE__ */ React.createElement("h5", null, t("details_view.description"))), (eventProcedure == null ? void 0 : eventProcedure.description) ? /* @__PURE__ */ React.createElement(
    MarkdownPreview,
    {
      show: true,
      maxHeight: descriptionMaxHeight,
      noBackground: true,
      noBorder: true,
      value: eventProcedure.description,
      noPadding: true
    }
  ) : /* @__PURE__ */ React.createElement(Alert, { style: { width: "100%" } }, t("details_view.no_description"))), /* @__PURE__ */ React.createElement(Col, null, withAssocEntities && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SectionHeaderRow, null, /* @__PURE__ */ React.createElement("h5", null, t("details_view.associated_event_definitions"))), ((_b = (_a = eventProcedure == null ? void 0 : eventProcedure.associated_entities) == null ? void 0 : _a.event_definitions) == null ? void 0 : _b.length) > 0 ? /* @__PURE__ */ React.createElement(AssociatedEventDefs, { eventDefinitions: eventProcedure.associated_entities.event_definitions }) : /* @__PURE__ */ React.createElement(Alert, { style: { width: "100%" } }, t("details_view.no_associated_event_definitions"))), /* @__PURE__ */ React.createElement(SectionHeaderRow, null, /* @__PURE__ */ React.createElement("h5", null, t("details_view.event_procedure_steps"))), ((_c = eventProcedure == null ? void 0 : eventProcedure.steps) == null ? void 0 : _c.length) > 0 ? /* @__PURE__ */ React.createElement(StepListView, { steps: eventProcedure.steps, eventId }) : /* @__PURE__ */ React.createElement(Alert, { style: { width: "100%" } }, t("details_view.no_steps_added"))));
}
export default EventProcedureDetailsView;
